export const columns = [
  {
    accessorKey: "name",
    header: "Shed Type",
    type: "string",
    size: 200,
  },

  {
    accessorKey: "isActive",
    header: "Active",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.isActive || " "}`,
  },

  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
